import * as React from 'react';
import {withTranslation, WithTranslation, Trans} from 'react-i18next';
import {connect} from 'react-redux';
import {State} from '../../reducers';
import s from './fullscreen.scss';
import X from './x';
import {hideSubscriptionOverlay} from '../../actions';
import {bindActionCreators, Dispatch, ActionCreator} from 'redux';
import {subscribe, Subscribe} from '../../actions';
import biLogger from '@wix/web-bi-logger';
const bi = biLogger
  .factory({endpoint: 'updates'})
  .setDefaults({src: 19})
  .logger();

export interface FullscreenProps extends WithTranslation {
  visible: boolean;
  subscribed: boolean;
  subscribe: ActionCreator<Subscribe>;
  hideOverlay: () => void;
}

export class FullscreenCmp extends React.Component<FullscreenProps, null> {
  constructor(el?) {
    super(el);
    this.handleClick = this.handleClick.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
  }
  render () {
    const {visible, t, subscribed} = this.props;
    if (!visible) {
      return null;
    }

    return (
      <div data-hooks="subscription-overlay" className={s.fullscreen}>
        {subscribed ? (
            <div data-hooks="thankyou" className={s.thankyou}>
              <p className={s.title}>{t('subscription.thankyou')}</p>
              <p className={s.description}>{t('subscription.thankyou.description')}</p>
              <button className={s.button} onClick={this.handleCloseClick}>{t('subscription.thankyou.done')}</button>
            </div>
          ) : (
            <div className={s.subscriptionBox}>
              <p className={s.title} data-hooks="title">
                <Trans i18nKey="subscription.overlay.title" />
              </p>
              <p className={s.description} data-hooks="description">
                <Trans i18nKey="subscription.overlay.description" />
              </p>
              <button className={s.button} onClick={this.handleClick} data-hooks="subscribe">{t('subscription.overlay.subscribe')}</button>
            </div>
          )}
          <label data-hooks="close" className={s.close} onClick={this.handleCloseClick}>
            <X />
          </label>
      </div>
    );
  }
  handleClick() {
    return bi.log({evid: 345})
      .catch(() => Promise.resolve())
      .then(() => this.props.subscribe());
  }
  handleCloseClick() {
    this.props.hideOverlay();
  }
}

function mapStateToProps(state: State) {
  return {
    visible: state.subscriptions.overlay,
    subscribed: state.subscriptions.subscribed,
  };
}

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
  hideOverlay: hideSubscriptionOverlay,
  subscribe,
}, dispatch);

export const Fullscreen: any = withTranslation()(connect(mapStateToProps, mapDispatchToProps)(FullscreenCmp));
